module.exports = __webpack_public_path__ + "img/ejymjpg.48965a04.jpg";